export enum StripeCheckoutDisplayMode {
  Popup = 'popup',
  Overlay = 'overlay',
}
